import React from 'react';

export const SparklerIconComponent = ({
  className,
}: {
  className?: string;
}) => (
  <svg
    className={className}
    width='24'
    height='24'
    viewBox='0 0 512 512'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g
      transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
      fill='currentColor'
      stroke='none'
    >
      <path d='M3827 4798 c-11 -77 -57 -221 -103 -317 -154 -327 -440 -577 -783 -685 -45 -14 -91 -26 -102 -26 -10 0 -19 -4 -19 -10 0 -5 9 -10 19 -10 31 0 176 -48 260 -86 191 -88 409 -273 524 -445 99 -149 185 -358 204 -496 3 -24 9 -43 13 -43 4 0 10 19 13 43 19 138 105 347 204 496 111 167 318 345 506 435 82 40 245 96 276 96 12 0 21 5 21 10 0 6 -9 10 -21 10 -31 0 -194 56 -276 96 -188 90 -395 268 -506 435 -99 149 -185 358 -204 497 -3 23 -9 42 -13 42 -4 0 -10 -19 -13 -42z' />
      <path d='M1727 4037 c-39 -140 -127 -359 -199 -497 -257 -494 -603 -787 -1030 -874 -42 -9 -91 -16 -108 -16 -54 0 -32 -17 30 -23 311 -33 630 -221 863 -510 190 -234 358 -566 444 -874 15 -57 30 -103 33 -103 3 0 14 33 24 73 30 117 112 332 186 482 209 425 497 721 832 854 93 37 217 69 298 78 62 6 84 23 30 23 -17 0 -66 7 -108 16 -426 87 -773 382 -1030 874 -72 138 -160 357 -199 497 -15 57 -30 103 -33 103 -3 0 -18 -46 -33 -103z' />
      <path d='M3414 1872 c-87 -359 -362 -646 -701 -732 -29 -8 -53 -16 -53 -20 0 -3 29 -13 65 -22 277 -73 528 -300 642 -582 18 -45 41 -116 50 -158 10 -43 20 -78 23 -78 3 0 15 40 26 88 76 311 289 568 568 685 44 19 105 40 134 47 28 8 52 17 52 20 0 3 -24 12 -52 19 -29 8 -91 30 -138 50 -280 120 -489 373 -564 683 -11 48 -23 88 -26 88 -3 0 -15 -40 -26 -88z' />
    </g>
  </svg>
);

export default SparklerIconComponent;
